<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <ng-container>
      <div class="modal-title">
        <span>Sage Contact Selection</span>
        <div class="modal-subtitle">Investigation# {{ investigation?.nefcoNumber || investigation?.id }}</div>
      </div>
    </ng-container>
  </kendo-dialog-titlebar>
  <div class="model-body">
    <p>Contact {{ investigation?.BillTo | fullName }} does not exist in SAGE. You can either select an existing SAGE
      contact from the list below or create a new contact in SAGE. Selecting an existing contact will override the email
      in SAGE with the Extranet3 email.</p>
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(9,minmax(0,1fr))']">
      <kendo-gridlayout-item class="detail" [colSpan]="2">
        <p>
          Extranet Bill To Contact
        </p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="detail">
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="detail" [colSpan]="2">
        <span>
          Contact Name
        </span>
        <p>
          {{investigation.BillTo.firstName || ''}} {{investigation.BillTo.lastName || ''}}
        </p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="detail" [colSpan]="2">
        <span>
          Email Address
        </span>
        <p>
          <app-email-phone-view *ngFor="let contactEmail of investigation.BillTo?.Emails"
            [email]="contactEmail"></app-email-phone-view>
        </p>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(9,minmax(0,1fr))']">
      <ng-container *ngFor="let item of sageContacts">
        <kendo-gridlayout-item class="detail radio-item">
          <div class="kendo-radio">
            <input kendoRadioButton [name]="'sageKey'" [(ngModel)]="selectedSageId" type="radio" [value]="item?.id" />
          </div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="detail" [colSpan]="2">
          <span>
            Sage ID
          </span>
          <p>
            {{item?.id}}
          </p>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="detail" [colSpan]="2">
          <span>
            Contact Name
          </span>
          <p>
            {{item?.name}}
          </p>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="detail" [colSpan]="4">
          <span>
            Email Address
          </span>
          <p>
            {{item?.email1}} {{item?.email2 ? ', ' + item?.email2 : ''}}
          </p>
        </kendo-gridlayout-item>
      </ng-container>
      <kendo-gridlayout-item class="detail radio-item" [colSpan]="9">
        <div class="kendo-radio">
          <input kendoRadioButton [name]="'sageKey'" #new type="radio" [(ngModel)]="selectedSageId" [value]="'NEW'" />
          <kendo-label class="k-checkbox-label font-weight-600 checkbox-margin" style="margin-bottom: 0" [for]="new"
            text="Create new contact in SAGE"></kendo-label>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
  <kendo-dialog-actions layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-16" (click)="close(false)">Cancel</button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" [disabled]="!selectedSageId" (click)="submit()">Save</button>
  </kendo-dialog-actions>
</div>
